import { render, staticRenderFns } from "./RegistMailAddress.vue?vue&type=template&id=618827e6&scoped=true&lang=pug&"
import script from "./RegistMailAddress.vue?vue&type=script&lang=ts&"
export * from "./RegistMailAddress.vue?vue&type=script&lang=ts&"
import style0 from "./RegistMailAddress.vue?vue&type=style&index=0&id=618827e6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618827e6",
  null
  
)

export default component.exports